import { getBatchInfo, getDriverOrderCount, getDriverOrders, getStaffList, resetOrders } from "../actions/mmActions";
import { setBatchSelectionConfig, setSelectedBatchIds } from "../reducers/uiSlice";
import _ from 'lodash';
import { flattenOrders, getUserPreference } from "../utilities/common";

export function batchChange(dispatch, city, batchIds, isHideAssociated, isHideSubReferrer) {
    if(!dispatch){
        return
    }
    
    dispatch(getStaffList(city, 1)).then(()=>{
        dispatch(setSelectedBatchIds(batchIds))
        if(isHideAssociated !== undefined && isHideSubReferrer !== undefined){
            dispatch(setBatchSelectionConfig({
                isHideAssociated,
                isHideSubReferrer
            }))
        } else {
            console.warn('IS_HIDE_ASSOCIATED or IS_HIDE_SUB_REFERRER is using default value! This might cause mismatched order counts')
            isHideAssociated = false
            isHideAssociated = false
        }
        
        dispatch(resetOrders())
        if(batchIds.length > 0){
            dispatch(getBatchInfo(city, batchIds, isHideAssociated, isHideSubReferrer))
            dispatch(getDriverOrderCount(city, batchIds, isHideAssociated, isHideSubReferrer))
        }
    })
}

export function refreshExistOrders(dispatch, ordersByDriver, orderId, currentBatchIds){
    const userPref = getUserPreference()
    if(!dispatch)
        return

    let orders = flattenOrders(ordersByDriver)
    
    let findOrder = _.find(orders, {'order_id': orderId})
    if(findOrder){
        dispatch(getDriverOrders(findOrder.shipping_staff_id, currentBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
    }
}